import React from "react";
import { useSelector } from "react-redux";
import { languages } from "../languages";
import { BiError } from "react-icons/bi";

const ErrorDisplay = ({ error }) => {
  const currentLang = useSelector((state) => state.settings.language);

  return (
    <center className="d-flex w-100  flex-column">
      <div style={{ marginTop: "5rem" }}>
        <span style={{ fontSize: "1.8rem", fontWeight: "bold", color: "#4A4A4A" }}>
          {languages.generalText[currentLang].error}!
        </span>
        <br />
        <BiError size="128px" color="#4A4A4A" />
        <br />
        <div style={{ height: "300px", width: "60%", color: "#4A4A4A" }}>{error}</div>
      </div>
    </center>
  );
};

export default ErrorDisplay;
